/* JUCE push - the shop's half of push.juce.co.za.
 *
 * THE YES HAPPENS HERE, ON juce.co.za. A push subscription belongs to a
 * service worker on the page's own origin, and this file used to open a
 * window on push.juce.co.za for that, on the belief that a Shopify theme
 * could never serve one. It can: Shopify serves theme assets on the store's
 * own domain (juce.co.za/cdn/shop/t/<n>/assets/...), which IS this page's
 * origin, so assets/juce-sw.js is registered from there and the browser's
 * permission prompt opens on the very tap that asked for it. One tap:
 * "Notify me", then Allow. The worker's scope is the assets folder, which
 * controls no page and intercepts nothing - a push does not care about scope.
 *
 * THE BROWSER ANSWERS IN ONE OF THREE WAYS, AND THE CARD SAYS WHICH
 * (2026-09-05). The first build only knew "granted": a "denied" made the
 * card vanish, and a prompt that was tucked away unanswered left it sitting
 * there saying nothing. Both read as "the browser blocked it" (owner: "gets
 * blocked for mobile regardless", "the browser seems to automatically block
 * the allow thingy"), and the second one IS what a browser in quiet mode
 * does: Chrome enrols anyone who has dismissed a few prompts, and a site with
 * a low yes-rate, in its quiet UI, where the ask is a crossed-out bell in
 * the address bar labelled "Notifications blocked" (on Android a small bar
 * along the bottom) that collapses after a moment and resolves the request
 * as 'default'. Nothing on a page can turn that off; what a page can do is
 * say where the question went, and finish the job the moment the person
 * finds it. So:
 *   - 'granted'  -> subscribe, as before.
 *   - 'default'  -> the card says the browser tucked the question away and
 *                   where to look, and WATCHES the permission: an Allow
 *                   given on the bell a minute later completes the
 *                   subscription with no second tap.
 *   - 'denied'   -> the card says notifications are blocked for juce.co.za
 *                   in this browser and how to unblock them, step by step
 *                   for the browser in hand, with the push host's own page
 *                   as another way in (a different origin, its own
 *                   permission). It watches too, for the unblock. A PRIVATE
 *                   OR INCOGNITO WINDOW is named first (owner, 2026-09-05:
 *                   "I opened an incognito tab, it just blocked with that
 *                   message"): Chrome never allows notifications there and
 *                   answers 'denied' on its own after a short pause, with no
 *                   prompt and no site setting to change. A page cannot tell
 *                   a private window from a blocked site, so the card says
 *                   both, private first.
 *
 * THE CARD OPENS WEARING THE TRUTH (2026-09-08, owner: "tapped notify me yet
 * the audience list is not increasing"). The build before this one showed
 * every browser the plain offer and let the tap find out what it was really
 * looking at. The first week's numbers said what that costs: of 100 taps, 41
 * went to a browser that was already refusing before anyone touched anything
 * and 31 to an iPhone that has to install the shop first - 72 taps on a
 * button that could not have worked, and four real subscribers. So the face
 * is decided BEFORE the card comes up (faceNow), and "Notify me" is only
 * offered where a yes can happen on that tap. A browser reading 'denied' gets
 * the unblock steps on sight, whether or not it ever refused this card.
 * AND THE COUNTERS TELL THE TWO APART. 'denied' is a refusal: a prompt was
 * opened and the answer was no. 'blocked' is a browser that never opened one,
 * because it was refusing already. Both used to be 'denied', which is why a
 * week of leaking could be seen but not read. Beside them: 'go' is a tap on
 * the OFFER only - the blocked face wears the same button as "Try again", and
 * counting that as a fresh attempt is what made go and denied climb together
 * while nobody subscribed.
 *
 * AN iPHONE IS ITS OWN STORY. Apple delivers web push only to a site opened
 * from the Home Screen, and a Safari tab has no PushManager at all - which
 * is why the card never even appeared on an iPhone before. Now it does, and
 * the tap explains the three taps (Share, Add to Home Screen, open JUCE from
 * there) right on the card rather than in a popup on the push host. The
 * theme carries a web app manifest (assets/manifest.json) so that the
 * Home Screen copy of juce.co.za runs as a web app on iOS 16.4 and up, where
 * this same card, this same worker and this same one tap then work. On
 * iOS 26 every Home Screen site is a web app by default. An in-app browser
 * (Instagram, Facebook, TikTok, WhatsApp) has no push anywhere; the card
 * says to open the page in a real browser.
 *
 * THE WINDOW STAYS FOR TWO JOBS. Choosing what to hear about, and turning it
 * off, live on push.juce.co.za/prefs, opened small with the subscription's
 * token; and a browser that cannot subscribe here (a worker the CDN would
 * not serve, or one that blocked juce.co.za and takes the other way in)
 * still gets the window. hello/identity/done over postMessage,
 * origin-checked both ways, nothing personal in the URL.
 *
 * WHEN IT ASKS. Never before the cookie banner has been answered (two
 * questions at once is how neither gets read), never on the first page,
 * never inside the cart or checkout. Every one of those numbers, and the
 * words on the card, come from the push console (/api/push/config) so they
 * can move without a theme deploy. The theme setting is only the switch.
 *
 * AND IT ASKS AGAIN, BUT ONLY WHERE ASKING AGAIN COULD WORK. Anyone who has
 * not said yes is asked again after the console's re-ask days (owner,
 * 2026-09-05: "reprompt them every 3 days when they visit the website so
 * that we can eventually get them"): a Maybe later, a no given in the
 * window, an ask left unanswered. Only a yes ends it. SINCE 2026-10-16 THE
 * WAIT IS SEVEN DAYS EVERY TIME, PER DEVICE (ASK_WAIT; the console's days
 * can only make it longer), and a card nobody answered does not follow the
 * person to the next page: moving on is a no for this week.
 *
 * TWO LANES ARE NOW SHUT INSTEAD OF RE-ASKED (2026-09-12, owner: "on mobile
 * sometimes I get the notify request that says blocked with a massive
 * anoying instruction message, that is too complicated for your average
 * user... if there is no way to get the notification request to show then
 * rather don't just keep trying when it triggers in it's intervals"). A
 * browser reading 'denied' is shown NOTHING uninvited - not the offer, not
 * the steps - and is never asked again while that stands; the loss is
 * counted once and the lane re-opens by itself if the person ever unblocks
 * the site, because the permission is read live. And a browser that has
 * swallowed the prompt twice is in Chrome's quiet UI, which no page can turn
 * off, so it is left alone too. The unblock steps still exist, shorter, for
 * the one person who asks for them: the footer's door, or a "Notify me" that
 * is refused on the tap. THE LANES THAT ASK FOR AN INSTALL KEEP THEIR OWN, MUCH
 * SLOWER CADENCE (INSTALL_WAIT, 2026-09-08): three days is right for a person
 * who could have said yes and put it off, and it is nagging for an iPhone or
 * an in-app browser being asked to go and move the shop somewhere else first.
 * The wait rides on the local mark beside the state, so the face that settled
 * an ask is what sets when it comes back.
 *
 * AND A YES IS THE END OF IT (owner, 2026-09-07: "once they opted in don't
 * show that message afterwards, they are now just opted in; if they want to
 * modify it they can go to the footer"). The card leaves the moment the
 * subscription is saved - no receipt, no manage door on it - and never comes
 * back to a browser that is in. Managing what to hear about is the footer's
 * job. The browser's own subscription is the truth of "in", not only the
 * local mark: a subscribed browser whose storage was cleared (Safari does
 * that on its own after a week away) is recognised on arrival and left
 * alone, and a browser whose Allow arrived after the page was left (the
 * bell in the address bar, a minute later) is quietly finished, with no
 * card. SINCE 2026-09-10 THE SERVER HAS THE LAST WORD ON "IN" (audit
 * finding F3): once a day the page shows the push host its subscription
 * (POST /api/push/sync) and files it again, drops it, or leaves it, as the
 * answer says - see settle() - and a yes whose POST never landed is kept as
 * a pending mark and filed on the next visit.
 *
 * Any element carrying data-push-open is a door too: the footer link, a
 * Jennie chip. Doors ignore the timing rules - a person who taps "manage
 * push notifications" has already decided - and a door in a browser that is
 * already in opens the manage page instead of asking again.
 */
(function () {
  'use strict';
  const conf = (window.theme && window.theme.push) || null;
  if (!conf || !conf.endpoint) return;

  let ORIGIN = '';
  try { ORIGIN = new URL(conf.endpoint).origin; } catch (e) { return; }

  /* ------------------------------------------------ can the yes be here */
  const ua = navigator.userAgent || '';
  const ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  const android = /Android/i.test(ua);
  const inApp = /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly|WhatsApp|Line\/|Snapchat/i.test(ua);
  const firefox = /Firefox\//i.test(ua);
  const chromish = /Chrome\/|Chromium\/|CriOS\//i.test(ua);
  const safari = /Safari\//i.test(ua) && !chromish && !firefox;
  const standalone = Boolean((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true);
  /* An iPhone counts as supported even where its Safari tab exposes no
     PushManager: the offer there is the Home Screen, and the card is where
     that is explained. */
  const supported = 'serviceWorker' in navigator
    && ('Notification' in window || ios)
    && ('PushManager' in window || ios);
  function perm() { return 'Notification' in window ? Notification.permission : 'default'; }

  /* The worker: the theme's own asset, which has to sit on this page's
     origin (the browser refuses anything else), with the push host's origin
     riding in the query so the worker knows where to report. */
  const SW = (function () {
    if (!conf.sw) return null;
    try {
      const u = new URL(String(conf.sw), location.href);
      if (u.origin !== location.origin) return null;
      u.searchParams.set('api', ORIGIN);
      return u.href;
    } catch (e) { return null; }
  })();
  const SW_BASE = SW ? SW.split('?')[0] : '';
  /* Where the tap can become the prompt on this very page. An iPhone outside
     a Home Screen app and an in-app browser get their explanation on the
     card instead (the click handler sorts them before this is asked). */
  const here = Boolean(supported && SW && 'PushManager' in window && !inApp && !(ios && !standalone));
  /* Whether the install card is on this page at all. It is the theme switch,
     not a guess: where it is on, the Home Screen ask belongs to it. */
  const installOffered = Boolean(window.theme && window.theme.install && window.theme.install.enabled);
  /* Is the install question closed on this browser? Installed, or asked and
     answered at least once, or nothing there to ask for. Read fresh every
     time: the install offer can arrive a second after this file loads. */
  function installSettled() {
    let i = {};
    try { i = JSON.parse(localStorage.getItem('juce:inst:v1') || '{}') || {}; } catch (e) { return true; }
    if (i.state === 'in') return true;
    if (i.verdict === 'none') return true;
    return Number(i.asks || 0) >= 1 && i.state !== 'showing';
  }

  const STORE = 'juce:push:v1';
  const PV = 'juce:push:pv';
  const CFG = 'juce:push:cfg';
  const DAY = 86400000;
  /* THE LANES THAT ASK FOR AN INSTALL KEEP THEIR OWN CADENCE (2026-09-08).
     The console's re-ask days are for a person who could have said yes and
     put it off; an iPhone and an in-app browser are being asked to go and
     move the shop somewhere else first, and asking that again every three
     days is nagging, not persuasion. 31 iPhone asks in the first week
     produced no subscription at all, so the ask costs something and returns
     nothing at that pace. */
  const INSTALL_WAIT = 21 * DAY;
  /* SEVEN DAYS, EVERY TIME, PER DEVICE (owner, 2026-10-16: "should ask
     once and then after 7 days again per device and if already approved not
     to show again, if you do not respond to it and nagivate to a different
     page it should disappear"). This replaces the 3, 9, 27, 60 day ladder
     of 2026-09-23: every Maybe later, and every ask left unanswered, waits
     seven days, and only a yes ends it. The console's re-ask days can make
     the wait longer, never shorter than ASK_WAIT. */
  const ASK_WAIT = 7 * DAY;
  function reaskWait(c) {
    const days = Number(c && c.prompt && c.prompt.reaskDays) || 0;
    return Math.max(ASK_WAIT, days * DAY);
  }

  function read() { try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
  function write(patch) { try { localStorage.setItem(STORE, JSON.stringify(Object.assign(read(), patch))); } catch (e) { /* private mode */ } }
  function pageviews() {
    let n = 0;
    try { n = Number(sessionStorage.getItem(PV) || 0) + 1; sessionStorage.setItem(PV, String(n)); } catch (e) { n = 1; }
    return n;
  }

  /* A count, and nothing else: the card was shown, tapped, or put off, and
     what the browser answered. No id rides with it and no cookie is sent, so
     it is the counting a refused banner still permits. Fire and forget. */
  function count(e) {
    try {
      fetch(ORIGIN + '/api/push/prompt', {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'content-type': 'application/json' }, body: JSON.stringify({ e: e }),
      }).catch(() => {});
    } catch (err) { /* nothing to count with */ }
  }

  let cfg = null;
  async function config() {
    if (cfg) return cfg;
    try {
      const raw = sessionStorage.getItem(CFG);
      if (raw) { const c = JSON.parse(raw); if (c && c.at && Date.now() - c.at < 10 * 60000) { cfg = c.cfg; return cfg; } }
    } catch (e) { /* fall through */ }
    try {
      const r = await fetch(ORIGIN + '/api/push/config', { mode: 'cors', credentials: 'omit' });
      if (!r.ok) return null;
      cfg = await r.json();
      try { sessionStorage.setItem(CFG, JSON.stringify({ at: Date.now(), cfg: cfg })); } catch (e) { /* fine */ }
      return cfg;
    } catch (e) { return null; }
  }

  /* Who is standing here, as far as the shop can say. The visitor id is only
     offered when that browser granted personalisation - attaching a journey
     to a subscription IS the identity join the grant is about. The server
     re-checks the same grant against its own consent row before using it,
     and for a subscribe made from this page it reads the id off the cookie
     alone (juce_vid is .juce.co.za-scoped, so it rides along). */
  function identity() {
    const jc = window.juceConsent || null;
    const grants = jc && Array.isArray(jc.grants) ? jc.grants.slice() : [];
    let aid = null;
    if (grants.indexOf('personalisation') !== -1) {
      try { const s = JSON.parse(localStorage.getItem('juce:loom:v1') || '{}'); if (s && typeof s.aid === 'string') aid = s.aid; } catch (e) { aid = null; }
    }
    const c = (window.theme && window.theme.customer) || null;
    const customer = c && c.signed_in && c.id != null && c.proof
      ? { id: c.id, email: c.email || null, proof: c.proof }
      : null;
    return { type: 'juce-push:identity', aid: aid, customer: customer, grants: grants };
  }

  function b64ToBytes(s) {
    const pad = '='.repeat((4 - (s.length % 4)) % 4);
    const raw = atob((s + pad).replace(/-/g, '+').replace(/_/g, '/'));
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
  }
  /* Is this subscription bound to the server key we hand out today? */
  function sameKey(sub, key) {
    try {
      const have = sub.options && sub.options.applicationServerKey;
      if (!have) return true;
      const a = new Uint8Array(have); const b = b64ToBytes(key);
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    } catch (e) { return true; }
  }
  /* pushManager.subscribe needs the worker ACTIVE, and
     navigator.serviceWorker.ready is the wrong thing to wait on: it answers
     for the worker that controls THIS page, and ours controls nothing (its
     scope is the assets folder), so it would wait forever. Wait on the
     registration itself. */
  function activated(reg) {
    return new Promise((resolve, reject) => {
      if (reg.active) { resolve(reg.active); return; }
      const w = reg.installing || reg.waiting;
      if (!w) { reject(new Error('The worker did not start.')); return; }
      const t = setTimeout(() => { reject(new Error('The worker took too long to start.')); }, 15000);
      w.addEventListener('statechange', function onState() {
        if (w.state === 'activated') { clearTimeout(t); w.removeEventListener('statechange', onState); resolve(w); }
        else if (w.state === 'redundant') { clearTimeout(t); w.removeEventListener('statechange', onState); reject(new Error('The worker could not start.')); }
      });
    });
  }
  /* Every registration of OUR worker in this browser, whichever theme
     version registered it. */
  async function ours() {
    const out = [];
    try {
      for (const r of await navigator.serviceWorker.getRegistrations()) {
        const w = r.active || r.waiting || r.installing;
        if (w && /\/assets\/juce-sw\.js(\?|$)/.test(w.scriptURL)) out.push(r);
      }
    } catch (e) { /* none */ }
    return out;
  }
  function workerOf(r) { const w = r.active || r.waiting || r.installing; return w ? w.scriptURL.split('?')[0] : ''; }
  /* The subscription this browser holds for us, and the registration it is
     under: the current theme's worker first, an older one's if that is all
     there is (reconcile() moves those). */
  async function held() {
    let found = null;
    try {
      for (const r of await ours()) {
        const sub = await r.pushManager.getSubscription();
        if (!sub) continue;
        if (workerOf(r) === SW_BASE) return { reg: r, sub: sub };
        if (!found) found = { reg: r, sub: sub };
      }
    } catch (e) { /* none this page can see */ }
    return found;
  }
  async function sha256hex(s) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(s)));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
  }
  /* THE TOKEN, LEFT FOR THE WORKER (2026-09-10, F3). A browser can rotate
     its subscription and hand the worker no old one to prove it (Firefox
     does); the row's own token is then the only proof the new address is
     the same person's, and a worker cannot read localStorage - so the token
     is also kept in this origin's Cache Storage, at the one address the
     push host's sw.js reads (TOKEN_URL there). */
  const TOKEN_URL = location.origin + '/__juce-push/token';
  function keepToken(t) {
    try { if (t && window.caches) caches.open('juce-push').then((c) => c.put(TOKEN_URL, new Response(String(t)))).catch(() => {}); } catch (e) { /* no cache here */ }
  }
  function dropToken() {
    try { if (window.caches) caches.open('juce-push').then((c) => c.delete(TOKEN_URL)).catch(() => {}); } catch (e) { /* no cache here */ }
  }

  /* THE PERMISSION, WATCHED. After an unanswered or a refused prompt the
     answer can still arrive without this page being touched: an Allow on
     the bell in the address bar, a switch flipped in the site settings.
     PermissionStatus.onchange hears it where the Permissions API exists; a
     slow poll of Notification.permission hears it everywhere else. One
     watcher at a time, and it gives up on its own. */
  let watching = null;
  function watchPermission(from, ms, cb) {
    if (watching) watching();
    let status = null; let poll = 0; let timer = 0; let done = false;
    const stop = () => {
      if (done) return;
      done = true; clearInterval(poll); clearTimeout(timer);
      if (status) { try { status.onchange = null; } catch (e) { /* fine */ } }
      if (watching === stop) watching = null;
    };
    const check = () => { if (done) return; const p = perm(); if (p !== from) { stop(); cb(p); } };
    try {
      navigator.permissions.query({ name: 'notifications' })
        .then((s) => { if (done) return; status = s; s.onchange = check; check(); })
        .catch(() => {});
    } catch (e) { /* no Permissions API: the poll is enough */ }
    poll = setInterval(check, 1500);
    timer = setTimeout(stop, ms);
    watching = stop;
    return stop;
  }

  /* ---------------------------------------------------------- the window */
  let child = null;
  function openWindow(page) {
    const back = location.href.split('#')[0];
    const s = read();
    let url = ORIGIN + (page === 'prefs' ? '/prefs' : '/subscribe') + '?r=' + encodeURIComponent(back);
    /* A subscription taken on this page is known to the window by its
       token only; one the window took itself it remembers on its own. */
    if (page === 'prefs' && s.token) url += '&t=' + encodeURIComponent(s.token);
    const w = Math.min(460, window.innerWidth - 20);
    const h = Math.min(700, window.innerHeight - 20);
    const left = Math.max(0, Math.round((window.screenX || 0) + (window.outerWidth - w) / 2));
    const top = Math.max(0, Math.round((window.screenY || 0) + (window.outerHeight - h) / 2));
    let win = null;
    try { win = window.open(url, 'juce-push', 'popup=yes,width=' + w + ',height=' + h + ',left=' + left + ',top=' + top); } catch (e) { win = null; }
    if (!win) { location.assign(url); return; }
    child = win;
    /* A window shut with its own X answered nothing, so the card stays up:
       the question is still open. Only the window's own message (done,
       denied, off) or "Maybe later" on the card settles it. */
    const watch = setInterval(() => {
      let closed = false;
      try { closed = !child || child.closed; } catch (e) { closed = true; }
      if (!closed) return;
      clearInterval(watch);
      child = null;
    }, 600);
  }

  /* Turned off in the window: the server row is already off, this drops the
     browser's own subscription so the address is really gone. */
  async function localOff() {
    dropToken();
    try {
      for (const r of await ours()) {
        const sub = await r.pushManager.getSubscription();
        if (sub) await sub.unsubscribe();
      }
    } catch (e) { /* the server side is what counts */ }
  }

  window.addEventListener('message', (e) => {
    if (e.origin !== ORIGIN) return;
    const d = e.data || {};
    if (d.type === 'juce-push:hello') {
      try { (e.source || child).postMessage(identity(), ORIGIN); } catch (err) { /* window gone */ }
      return;
    }
    if (d.type === 'juce-push:done') {
      if (d.ok) write({ state: 'on', at: Date.now() });
      else if (d.why === 'denied' || d.why === 'unsupported') write({ state: 'off', at: Date.now(), wait: 0 });
      else if (d.why === 'off') { write({ state: 'later', at: Date.now(), token: null, here: false, wait: 0 }); void localOff(); }
      hide();
    }
  });

  /* ------------------------------------------------------------- card */
  const card = document.querySelector('[data-pushp]');
  const $ = (sel) => (card ? card.querySelector(sel) : null);
  let shown = false;
  /* Which face is on screen. The button is the same element on all of them,
     so this is what tells a tap on the offer ("Notify me", which will open a
     prompt) from a tap on the blocked face ("Try again", which cannot). */
  let wearing = 'offer';
  /* The words the card was born with (the first paint, from Liquid), so the
     offer can be put back after the card has been something else. */
  const base = (function () {
    const t = (sel) => { const el = $(sel); return el ? el.textContent : ''; };
    return { title: t('[data-pushp-title]'), body: t('[data-pushp-body]'), cta: t('[data-pushp-go]'), later: t('.pushp__link[data-pushp-later]') };
  })();
  function words() {
    const p = (cfg && cfg.prompt) || {};
    return { title: p.title || base.title, body: p.body || base.body, cta: p.cta || base.cta, later: p.later || base.later };
  }

  /* One card, several faces. The offer; the browser's answer explained; the
     Home Screen steps. Every face is the same anatomy (eyebrow,
     title, words, optional steps, one button, a quiet line under it), so
     none of them is a surprise after the one before. */
  function view(o) {
    if (!card) return;
    const set = (sel, text) => { const el = $(sel); if (el && typeof text === 'string') el.textContent = text; };
    set('[data-pushp-title]', o.title);
    set('[data-pushp-body]', o.body);
    const ol = $('[data-pushp-steps]');
    if (ol) {
      ol.textContent = '';
      for (const s of (o.steps || [])) { const li = document.createElement('li'); li.textContent = s; ol.appendChild(li); }
      ol.hidden = !(o.steps && o.steps.length);
    }
    const acts = $('.pushp__acts'); if (acts) acts.hidden = !o.cta;
    const go = $('[data-pushp-go]'); if (go && o.cta) go.textContent = o.cta;
    const later = $('.pushp__link[data-pushp-later]');
    if (later) { later.hidden = o.later === false; if (typeof o.later === 'string') later.textContent = o.later; }
    const alt = $('[data-pushp-alt]'); if (alt) alt.hidden = !o.alt;
  }
  /* The offer itself, in the console's words. */
  function offer() { wearing = 'offer'; const w = words(); view({ title: w.title, body: w.body, cta: w.cta, later: w.later }); }
  function fill(c) { if (c && c.prompt) offer(); }

  /* WHICH FACE THIS ASK WEARS, DECIDED BEFORE IT COMES UP (2026-09-08, owner:
     "tapped notify me yet the audience list is not increasing"). The build
     before this one showed every browser the plain offer and let the tap find
     out what it was really looking at. In the first week that cost 41 taps to
     browsers that were already refusing and 31 to iPhones that have to
     install the shop first: 72 of 100 taps on a button that could not have
     worked, and a funnel in which none of it was visible. So the card now
     opens wearing the truth. Nobody is offered "Notify me" unless a yes can
     actually happen on that tap. */
  function faceNow() {
    if (inApp) return 'inapp';
    /* ONE ASK FOR ONE ACTION (2026-09-12). On an iPhone outside an installed
       window, this card's Home Screen face and the install card's are the
       same three taps asked twice in the same corner, in different words -
       and they raced, so the second one to arrive landed on top of the first.
       The install card owns that ask now: it is the install ask, it wears the
       browser's own face, and a person who does it lands in a Home Screen
       JUCE where THIS card's one tap works properly on the next visit. So
       push says nothing to an iPhone tab while the install offer is on the
       page, and nothing is counted, because the ask was not push's to make.
       Switch the install offer off in the theme and the old face comes back. */
    if (ios && !standalone) return installOffered ? null : 'homescreen';
    /* A BROWSER THAT IS ALREADY REFUSING IS NOT SHOWN ANYTHING AT ALL
       (2026-09-12, owner: "on mobile sometimes I get the notify request that
       says blocked with a massive anoying instruction message, that is too
       complicated for your average user... if there is no way to get the
       notification request to show then rather don't just keep trying").
       The build before this one opened the card already wearing the unblock
       steps, cold, to anybody whose permission read 'denied' - and then
       again every three days. That was right about the arithmetic and wrong
       about the person: it is a wall of settings instructions shown to
       somebody who did not ask a question, most often in a private window
       where there is nothing to unblock in the first place, and no amount of
       repeating it turns into a subscriber. So this face is now only ever
       reached by a deliberate tap: the footer's door, or "Notify me" on a
       browser that refuses the moment it is pressed. Uninvited, the ask is
       simply not made - counted once, so the funnel still shows what was
       lost, and then left alone for good. */
    if (here && perm() === 'denied') return 'quiet';
    return 'offer';
  }
  /* The card, put up wearing that face and counted once for this ask. */
  function present() {
    const f = faceNow();
    /* Nothing to ask and nothing worth saying: record the loss once, close
       the lane for this browser, and show no card. */
    if (f === 'quiet') { markAsk('blocked', 'blocked', 0); write({ quiet: true }); return; }
    /* The install card is making this ask instead. Nothing shown, nothing
       counted, and no mark written: this browser has not been asked at all,
       so it stays eligible for the day it comes back as an installed JUCE. */
    if (!f) return;
    if (f === 'inapp') inapp();
    else if (f === 'homescreen') homescreen();
    else { offer(); markAsk(null, 'showing', 0); }
    show();
  }

  /* What the browser is doing, in one line under the button. */
  function say(text, tone) {
    const el = $('[data-pushp-status]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-bad', tone === 'bad');
  }
  function lift() {
    if (!card) return;
    const dock = document.querySelector('.dock');
    const apply = () => {
      const h = dock ? Math.round(dock.getBoundingClientRect().height) : 0;
      card.style.setProperty('--pushp-lift', (h > 0 ? h : 0) + 'px');
    };
    apply();
    if (dock && 'ResizeObserver' in window) new ResizeObserver(apply).observe(dock);
  }
  function show() {
    if (!card) return;
    lift();
    card.hidden = false;
    void card.offsetHeight;
    card.classList.add('is-up');
  }
  /* THE ASK, COUNTED ONCE, WITH THE FACE IT WORE. Every ask is a 'shown' so
     the top of the funnel keeps meaning what it always meant; beside it goes
     the face, because an ask that came up already saying "your browser is
     refusing" is not the same offer as one with a live button on it, and
     reading them as one number is what hid a week of wasted taps.
     UP FOR THIS PAGE ONLY (owner, 2026-10-16: "if you do not respond to it
     and nagivate to a different page it should disappear"). Until then it
     stayed up across pages until answered (2026-09-03). 'showing' is now an
     ask that went unanswered: the next page does not bring it back, and it
     waits the same seven days as a Maybe later, counted from the moment it
     came up. The faces that cannot be answered here settle themselves and
     carry their own wait. */
  function markAsk(face, state, wait) {
    /* No card in the page is no ask: the count used to sit inside show(),
       behind its own guard, and moving it out here must not start counting
       asks that nobody could have seen. */
    if (!card || shown) return;
    shown = true;
    const s = read();
    /* 'asked' is a tap whose answer the browser is still holding: that
       card resumes on the next page and is the same ask, not a new one. */
    if (s.state === 'asked') return;
    write({ state: state, at: Date.now(), wait: wait || 0 });
    count('shown');
    if (face) count(face);
  }
  function hide() {
    if (!card || card.hidden) return;
    card.classList.remove('is-up');
    setTimeout(() => { card.hidden = true; }, 260);
  }
  /* The card after a yes: gone. The browser's own prompt was the answer,
     the welcome notification is the receipt, and the footer is where what
     to hear about is chosen. Nothing more to say on the page. */
  function done() {
    if (watching) watching();
    say('');
    hide();
    paintOffers();
  }

  /* ------------------------------------------ the browser's other answers */
  /* Where the question went, for the browser in hand. Chrome's quiet UI is
     the common case: a crossed-out bell in the address bar that it labels
     "Notifications blocked", a small bar along the bottom on Android. */
  function whereItWent() {
    if (firefox) return 'Firefox is holding it behind the small bell beside the address. Click it and choose Allow.';
    if (safari) return 'Choose Allow when Safari asks.';
    if (android) return 'Your browser tucked it into a small "Notifications blocked" bar at the bottom of the screen, or a bell beside the address. Tap it and choose Allow.';
    return 'Look for the crossed-out bell beside the address (your browser calls it "Notifications blocked"), click it and choose Allow.';
  }
  /* How to lift a block, for the browser in hand. */
  function unblockSteps() {
    if (ios) return [
      'Open the Settings app, then Notifications.',
      'Find JUCE in the list and turn Allow Notifications on.',
      'Come back here and tap Try again.',
    ];
    if (android) return [
      'Tap the lock or tune icon beside the address (or the three dots, then Site settings).',
      'Under Permissions, set Notifications to Allow. If your phone has notifications off for the browser itself, turn those on too.',
      'Come back here and tap Try again.',
    ];
    if (firefox) return [
      'Click the permissions icon beside the address (next to the lock).',
      'Next to Notifications, clear the Blocked setting.',
      'Tap Try again.',
    ];
    if (safari) return [
      'Open Safari\'s Settings, then Websites, then Notifications.',
      'Set juce.co.za to Allow.',
      'Tap Try again.',
    ];
    return [
      'Click the tune or lock icon on the left of the address bar.',
      'Set Notifications to Allow, then reload if the browser asks you to.',
      'Tap Try again.',
    ];
  }
  /* The prompt was shown and went unanswered - collapsed by a quiet UI,
     clicked away, or auto-dismissed. The question is still open, the card
     says where it is, and the permission is watched so an Allow found a
     minute later finishes the job with no second tap. */
  function tucked() {
    count('dismissed');
    wearing = 'tucked';
    /* HOW MANY TIMES THIS BROWSER HAS SWALLOWED THE QUESTION. Twice is not
       a coincidence and not somebody being slow: it is Chrome's quiet UI,
       which no page can turn off and which resolves the request as 'default'
       whether or not anybody ever saw the bell. eligible() shuts the lane at
       two, so the third ask is never made (2026-09-12). */
    try { write({ tucked: Number(read().tucked || 0) + 1 }); } catch (e) { /* private mode */ }
    /* 'asked': the tap was given and the browser is still holding the
       question. Only this state lets a later Allow (found on the next page)
       finish the subscription without another tap - a 'showing' card was
       never tapped, and a granted permission behind it may be an old one
       whose subscription was turned off on purpose. */
    write({ state: 'asked', at: Date.now(), wait: 0 });
    view({ title: 'Your browser tucked the question away', body: whereItWent() + ' Or tap Try again.', cta: 'Try again' });
    say('');
    watchPermission('default', 3 * 60000, (p) => {
      if (p === 'granted') { count('granted'); void subscribeHere(); }
      /* The question was found and answered no: a refusal, not a browser
         that was refusing all along. */
      else if (p === 'denied') blocked({ count: 'denied' });
    });
  }
  /* The browser refuses to ask: the site is set to Block, or an earlier
     prompt was dismissed enough times that the browser blocked it on the
     person's behalf. Only the person can lift that, so the card says how,
     offers the push host's page as another way in (its own origin, its own
     permission), and watches for the unblock. */
  function blocked(opts) {
    const o = opts || {};
    wearing = 'blocked';
    /* TWO DIFFERENT THINGS, COUNTED APART (2026-09-08). 'denied' is a
       refusal: the browser opened its prompt and the answer was no. 'blocked'
       is a browser that was already refusing before anyone tapped - a private
       window, notifications switched off for the browser itself, a standing
       block on the site - which never opened a prompt at all. One is copy to
       argue with, the other cannot be argued with, and counting both as
       "denied" is what made 41 of the first week's 100 taps unreadable. */
    if (o.count === 'denied') count('denied');
    else markAsk('blocked', 'blocked', 0);
    write({ state: 'blocked', at: Date.now(), wait: 0 });
    /* FRESH: the no arrived on this very tap, where a moment ago the
       permission was undecided - the browser answered without asking (a
       private or incognito window does exactly that, after a short pause)
       or Block was chosen just now. STANDING: it was already refusing before
       the tap. The private window is named first in both, because a page
       cannot tell it from a blocked site and it is the common case. */
    /* SHORT, BECAUSE IT IS NOW ONLY EVER READ BY SOMEBODY WHO ASKED FOR IT
       (2026-09-12, owner: "a massive anoying instruction message, that is
       too complicated for your average user"). This face is no longer put in
       front of anyone uninvited - see faceNow - so what is left is a person
       who has just pressed a button and is owed an answer. Two lines and the
       steps, not a paragraph of them: the private-window case is the common
       one and goes first, in one sentence, and the settings walk is the
       list underneath for the few who need it. */
    view(o.fresh ? {
      title: 'Your browser said no',
      body: 'In a private or incognito window notifications are never allowed. Otherwise Block was chosen, and it can be undone:',
      steps: unblockSteps(), cta: 'Try again', alt: true,
    } : {
      title: 'Notifications are off for this browser',
      body: 'It is refusing to ask. A private window always does; otherwise the site was blocked here before. To allow it:',
      steps: unblockSteps(), cta: 'Try again', alt: true,
    });
    say('');
    watchPermission('denied', 10 * 60000, (p) => {
      if (p === 'granted') { count('granted'); void subscribeHere(); }
      else { offer(); say('Unblocked. Tap Notify me.'); write({ state: 'showing', at: Date.now(), wait: 0 }); }
    });
  }
  /* An iPhone or iPad outside a Home Screen app. Apple only delivers push
     to a site opened from the Home Screen; the three taps are said here, on
     the card, and the Home Screen copy of the shop (a web app, thanks to
     the theme's manifest) asks with this same card on its first visit. */
  function homescreen() {
    wearing = 'homescreen';
    markAsk('homescreen', 'later', INSTALL_WAIT);
    view({
      title: 'One more step on iPhone',
      body: 'Apple only delivers notifications to sites on your Home Screen. It takes three taps:',
      steps: [
        'Tap the Share button in Safari.',
        'Choose Add to Home Screen, then Add.',
        'Open JUCE from your Home Screen and tap Notify me.',
      ],
      cta: null, later: 'Got it',
    });
    say('');
  }
  /* An in-app browser has no push in it at all. */
  function inapp() {
    wearing = 'inapp';
    markAsk('inapp', 'later', INSTALL_WAIT);
    view({
      title: 'Open this in your browser',
      body: 'The app you are in uses a built-in browser that cannot receive notifications. Open juce.co.za in Chrome or Safari and tap Notify me there.',
      cta: null, later: 'Got it',
    });
    say('');
  }

  /* ------------------------------------------------------ the yes, here */
  /* The yes, filed: the person's own tap and Allow, sent now - or, from the
     pending mark, on a later visit when the first POST never landed, which
     the server records as filed later (`pending`). Never throws. */
  async function postSubscribe(sub, p, later) {
    try {
      const res = await fetch(ORIGIN + '/api/push/subscribe', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          subscription: sub.toJSON(), topics: p.topics || [], marketing: Boolean(p.marketing),
          defaultOn: Boolean(p.defaultOn), touched: [],
          proof: read().token || null, identity: identity(),
          tz: (Intl.DateTimeFormat().resolvedOptions() || {}).timeZone || null,
          lang: navigator.language || null, standalone: standalone,
          page: p.page || location.href.split('#')[0].slice(0, 200),
          pending: Boolean(later), tappedAt: later ? p.at : undefined,
        }),
      });
      const out = await res.json().catch(() => ({}));
      return { ok: res.ok, status: res.status, token: out.token || null, error: out.error || null };
    } catch (e) {
      return { ok: false, status: 0, token: null, error: null };
    }
  }

  let busy = false;
  async function subscribeHere() {
    if (busy) return;
    busy = true;
    const go = $('[data-pushp-go]');
    if (go) go.disabled = true;
    /* THE ASK RIDES THE TAP. requestPermission() is called before anything
       is awaited: Safari and Firefox only open the prompt on a fresh user
       activation, and an await in front of it would spend that on nothing.
       The worker registers meanwhile. */
    const before = perm();
    const asked = before !== 'granted';
    const asking = asked ? Notification.requestPermission() : Promise.resolve('granted');
    const registering = navigator.serviceWorker.register(SW, { updateViaCache: 'none' });
    registering.catch(() => {});
    say('Your browser is asking. Choose Allow.');
    try {
      let p = 'default';
      try { p = await asking; } catch (e) { p = perm(); }
      /* Old Safari answered through a callback and returned nothing; the
         permission itself is the truth either way. */
      if (p !== 'granted' && p !== 'denied') p = perm();
      if (p === 'denied') { blocked({ fresh: before !== 'denied' }); return; }
      if (p !== 'granted') { tucked(); return; }
      if (asked) count('granted');
      if (watching) watching();
      say('Setting it up...');
      const c = cfg || (await config());
      if (!c || !c.enabled || !c.key) throw new Error('Notifications are switched off right now.');
      let reg = null;
      try { reg = await registering; await activated(reg); }
      catch (e) {
        /* The asset could not be a worker here (a CDN answering with the
           wrong type, a browser that will not take one from this path).
           Permission is already given; the window on the push host finishes
           the job the old way. */
        say('');
        openWindow('subscribe');
        return;
      }
      let sub = await reg.pushManager.getSubscription();
      /* A subscription bound to an OLD server key (the key was rotated) is
         dead at the push service; it is dropped and a fresh one minted. */
      if (sub && !sameKey(sub, c.key)) { try { await sub.unsubscribe(); } catch (e) { /* gone anyway */ } sub = null; }
      if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(c.key) });
      /* What a one-tap yes turns on: every service topic, and the marketing
         ones only when the console's dial says they start on. No switch was
         shown, so none was touched, and the consent record says so. The
         manage page is where they are chosen one by one. */
      const topics = (c.topics || []).filter((t) => t.purpose === 'service' || Boolean(c.marketingDefaultOn)).map((t) => t.key);
      const marketing = (c.topics || []).some((t) => t.purpose === 'marketing' && topics.indexOf(t.key) !== -1);
      /* THE PENDING MARK (2026-09-10, F3). The browser is subscribed from
         this line on; the server only knows once the POST below lands. A
         dropped connection, a closed tab, a push host restarting - and the
         browser held a subscription nobody had filed, which the next visit
         then took as "already in" and never asked about again. So what the
         person just agreed to is written down FIRST, and a later visit files
         it (settle) if this POST never finished. */
      const pending = { at: Date.now(), topics: topics, marketing: marketing, defaultOn: Boolean(c.marketingDefaultOn), page: location.href.split('#')[0].slice(0, 200) };
      write({ pending: pending });
      const out = await postSubscribe(sub, pending);
      if (!out.ok || !out.token) throw new Error(out.error || 'The subscription did not save.');
      write({ state: 'on', at: Date.now(), token: out.token, here: true, pending: null, syncAt: Date.now() });
      keepToken(out.token);
      done();
    } catch (err) {
      say((err && err.message) ? err.message : 'Something went wrong. Try again in a moment.', 'bad');
    } finally {
      busy = false;
      if (go) go.disabled = false;
    }
  }

  /* THE THEME MOVED. The worker's URL carries the theme's number, and a
     browser whose worker came from an earlier theme still has the old
     registration - which the browser drops the day that theme is deleted and
     its script answers 404. So a browser that is in re-homes on its next
     visit: the same address moves to the current worker and the server is
     told it is the same browser (the old key is the proof), before the old
     one is let go. Quiet, and only when there is something to move. */
  async function reconcile() {
    const s = read();
    if (s.state !== 'on' || !s.here || !here) return;
    try {
      for (const r of await ours()) {
        if (workerOf(r) === SW_BASE) continue;
        const old = await r.pushManager.getSubscription();
        if (!old) { void r.unregister(); continue; }
        const reg = await navigator.serviceWorker.register(SW, { updateViaCache: 'none' });
        await activated(reg);
        const key = (old.options && old.options.applicationServerKey) || null;
        const next = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key || undefined });
        const res = await fetch(ORIGIN + '/api/push/change', {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ old: old.toJSON(), subscription: next.toJSON() }),
        });
        const moved = res.ok ? await res.json().catch(() => ({})) : {};
        /* The old server answered only { ok }; this one says whether the move
           took and hands back the new row's token (2026-09-10). */
        if (!res.ok || moved.ok === false) { try { await next.unsubscribe(); } catch (e) { /* fine */ } continue; }
        if (moved.token) { write({ token: moved.token }); keepToken(moved.token); }
        try { await old.unsubscribe(); } catch (e) { /* gone anyway */ }
        void r.unregister();
      }
    } catch (e) { /* next visit */ }
  }

  /* IS THIS BROWSER IN - ASKED OF THE SERVER, NOT ASSUMED (2026-09-10, audit
     finding F3). After a yes the local mark says so, but the mark can go
     while the subscription stays (storage cleared by hand, or by Safari on
     its own after a week away), and the build before this one took the
     worker's subscription as the whole truth: any subscription at all meant
     "in". So a subscription whose server row was never filed (the POST
     lost), or one turned off on the manage page or by a colleague acting on
     the person's word, was "in" forever - quiet, and never asked again. Now,
     at most once a day, the page shows the server its endpoint and a hash of
     its key (POST /api/push/sync) and does what the answer says:
       active        in; the token comes back for the manage door;
       unsubscribed  turned off somewhere else: the browser's subscription is
                     dropped too, and the card asks again in its own time;
       unknown       the server has no live row for it: it is filed again
                     (refile), which never brings back what the person turned
                     off - the server answers 'unsubscribed' to that instead.
     A granted permission on its own is still not "in": it outlives a
     subscription that was turned off on purpose. */
  const PENDING_MAX = 7 * DAY;

  /* Turned off somewhere else: drop this browser's half of it as well. That
     is a no like any other, asked again at the console's cadence. */
  async function dropHere(sub) {
    try { await sub.unsubscribe(); } catch (e) { /* gone anyway */ }
    dropToken();
    write({ state: 'later', at: Date.now(), wait: 0, here: false, token: null });
  }

  /* Filed again: the browser's word, not a new yes (see refileSubscription
     on the server). The token the page kept names the row this browser had,
     so a subscription that moved while nobody was told comes home with its
     topics and consent. */
  async function refile(sub, token) {
    let res = null; let out = {};
    try {
      res = await fetch(ORIGIN + '/api/push/subscribe', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          subscription: sub.toJSON(), refile: true, replaces: token || null, proof: token || null,
          identity: identity(),
          tz: (Intl.DateTimeFormat().resolvedOptions() || {}).timeZone || null,
          lang: navigator.language || null, standalone: standalone,
          page: location.href.split('#')[0].slice(0, 200),
        }),
      });
      out = await res.json().catch(() => ({}));
    } catch (e) { return; }
    if (res.ok && out.token) { write({ state: 'on', at: Date.now(), here: true, token: out.token }); keepToken(out.token); return; }
    if (res.status === 409 && out.state === 'unsubscribed') await dropHere(sub);
  }

  /* The mark says this page subscribed the browser and the permission still
     stands, but the browser holds no subscription any more (the push service
     let it lapse, a rotation the worker could not finish). The person's yes
     stands and nothing of theirs said otherwise, so it is put back the way
     pushsubscriptionchange would have - quietly - and filed as a move of the
     row it replaces. If that cannot be done, the card may ask again. */
  async function restore(c, s) {
    let sub = null;
    try {
      const reg = await navigator.serviceWorker.register(SW, { updateViaCache: 'none' });
      await activated(reg);
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(c.key) });
    } catch (e) { sub = null; }
    if (!sub) { write({ state: 'later', at: 0, wait: 0, here: false }); return; }
    await refile(sub, s.token);
  }

  async function sync(c, h) {
    const s = read();
    write({ syncAt: Date.now() });
    if (!h) {
      if (s.state === 'on' && s.here) await restore(c, s);
      return;
    }
    if (!sameKey(h.sub, c.key)) {
      /* Bound to a key the server no longer signs with (a rotation retired
         every row): dead at the push service, and only a fresh yes can
         replace it, so the card is free to ask. */
      try { await h.sub.unsubscribe(); } catch (e) { /* gone anyway */ }
      dropToken();
      write({ state: 'later', at: 0, wait: 0, here: false, token: null });
      return;
    }
    let out = null;
    try {
      const j = h.sub.toJSON();
      const res = await fetch(ORIGIN + '/api/push/sync', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          endpoint: h.sub.endpoint,
          keyHash: await sha256hex(String((j.keys && j.keys.p256dh) || '').replace(/=+$/, '')),
          expirationTime: h.sub.expirationTime || null,
          identity: identity(),
        }),
      });
      if (res.ok) out = await res.json().catch(() => null);
    } catch (e) { out = null; }
    if (!out || !out.state) {
      /* The push host did not answer (or is an older build with no sync):
         do what this page always did - a subscription on the current key is
         in - and ask again tomorrow. */
      if (s.state !== 'on') write({ state: 'on', at: Date.now(), here: true });
      return;
    }
    if (out.state === 'active') {
      write({ state: 'on', here: true, token: out.token || s.token || null, at: s.state === 'on' ? s.at : Date.now() });
      keepToken(out.token);
      return;
    }
    if (out.state === 'unsubscribed') { await dropHere(h.sub); return; }
    if (out.state === 'unknown') await refile(h.sub, s.token);
  }

  /* Before the card decides anything: a yes whose POST never landed is
     filed, and the daily sync runs when it is due - every visit for a
     browser whose mark is not 'on' but which holds a subscription (storage
     cleared), once a day for one that is. */
  async function settle(c) {
    if (!here || perm() !== 'granted' || !c || !c.key) return;
    const s = read();
    const h = await held();
    if (s.pending && typeof s.pending === 'object') {
      if (!h || !sameKey(h.sub, c.key) || Date.now() - (Number(s.pending.at) || 0) > PENDING_MAX) {
        write({ pending: null });
      } else {
        const out = await postSubscribe(h.sub, s.pending, true);
        if (out.ok && out.token) {
          write({ state: 'on', at: Date.now(), token: out.token, here: true, pending: null, syncAt: Date.now() });
          keepToken(out.token);
          return;
        }
        /* Refused in words (a 4xx that is not "slow down"): the mark is
           spent, and the sync below says what is true. No answer at all:
           keep it for the next visit. */
        if (out.status >= 400 && out.status < 500 && out.status !== 429) write({ pending: null });
        else return;
      }
    }
    const now = read();
    const due = (now.state !== 'on' && h) || (now.state === 'on' && now.here && (!now.syncAt || Date.now() - Number(now.syncAt) > DAY));
    if (due) await sync(c, h);
  }

  function eligible(c) {
    if (!c || !c.enabled || !c.prompt) return false;
    if (!supported) return false;
    if (/^\/(cart|checkouts?|account\/login|account\/register|password)/.test(location.pathname)) return false;
    const s = read();
    if (s.state === 'on') return false;
    /* THE APP IS ASKED FOR FIRST, AND THIS ONE WAITS (2026-09-12, owner:
       "we need it to flow nicely, cookie consent, then perhaps app? and
       while they browse notify"). It is not only manners. On an iPhone a
       notification cannot be delivered at all until the shop is on the Home
       Screen, so asking to notify before asking to install is asking for
       something that cannot be given - and every ask that could not have
       worked is counted by Chrome against the site's acceptance rate, which
       is what puts a site into the quiet UI in the first place. Three
       questions in one visit is three refusals; two, spaced, is a
       conversation.

       assets/juce-install.js publishes its verdict in its own mark. This
       waits while there is an install to ask for and the matter is still
       open, and goes ahead the moment it is closed: installed, answered
       once, or nothing to ask for on this browser. No mark and no storage
       means no waiting, which is the safe direction to fail in. */
    if (installOffered && !installSettled()) return false;
    /* A BROWSER THAT IS STILL REFUSING IS NEVER ASKED AGAIN (2026-09-12).
       'blocked' used to sit in the re-ask list below with the rest, so a
       phone that had blocked the site was handed the settings instructions
       every three days for as long as it kept visiting. It is not an
       undecided answer: nothing on the page can change it, and only the
       person can, in a place the page cannot reach. The lane re-opens by
       itself the moment they do - the permission is read live here, so an
       unblock in the browser's settings makes this browser eligible again on
       the next page, which is the one case where asking again is worth
       anything. */
    if (s.state === 'blocked' && here && perm() === 'denied') return false;
    /* The quiet lanes, closed for good on this browser: the prompt was
       tucked away unanswered twice, which is a browser in Chrome's quiet UI
       and not a person who has not got round to it. */
    if (Number(s.tucked || 0) >= 2 && perm() !== 'granted') return false;
    /* Every other no is asked again after seven days: a Maybe later, a no
       in the window ('off'), and an ask left unanswered ('showing', the
       person moved on to another page). Only a yes ends it. */
    /* Seven days, unless the face that settled this ask carried a longer
       one of its own (the Home Screen steps, the in-app browser). */
    const reask = reaskWait(c);
    const wait = Number(s.wait) > 0 ? Number(s.wait) : reask;
    /* 'blocked' is deliberately not in this list any more: while the block
       stands the lane is shut above, and once it is lifted there is nothing
       left to wait for. */
    if ((s.state === 'later' || s.state === 'off' || s.state === 'showing') && Date.now() - (s.at || 0) < wait) return false;
    /* A 'blocked' whose block has since been lifted is eligible again. */
    return true;
  }

  /* The cookie card, or its preferences panel, is on screen. The push card
     never shares the screen with either: it waits, and if one of them opens
     while it is up it gets out of the way. */
  function gateOpen() {
    const g = document.querySelector('[data-gate]');
    const p = document.querySelector('[data-gate-panel]');
    /* The install card shares this corner and this right of way. It stands
       down for the push card on a browser where both could ask, so the
       courtesy has to run both ways or they land on top of each other. */
    const inst = document.querySelector('[data-inst]');
    return Boolean((g && !g.hidden) || (p && p.open) || (inst && !inst.hidden));
  }
  if ('MutationObserver' in window) {
    const watchGate = new MutationObserver(() => { if (gateOpen()) hide(); });
    /* The install card is watched too, so the courtesy is symmetrical: it
       already gets out of the way for this one, and without this line a card
       that came up a moment after this one's own check would land on top. */
    for (const sel of ['[data-gate]', '[data-gate-panel]', '[data-inst]']) {
      const el = document.querySelector(sel);
      if (el) watchGate.observe(el, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
    }
  }

  function whenDecided(cb) {
    const jc = window.juceConsent || null;
    if (!jc || jc.state !== 'undecided') { cb(); return; }
    /* ONLY AN ANSWER COUNTS (2026-09-14). juce-consent.js now also announces
       while the banner is still unanswered - the "measured on notice" event,
       state 'undecided' with `presumed` set - and taking that as the answer
       put this offer on top of an open banner. */
    document.addEventListener('juce:consent', function once(e) {
      const st = e && e.detail && e.detail.state;
      if (st === 'undecided') return;
      document.removeEventListener('juce:consent', once);
      cb();
    });
  }

  function whenVisible(cb) {
    if (document.visibilityState === 'visible') { cb(); return; }
    document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', once);
      cb();
    });
  }

  /* ------------------------------------------------------------- boot */
  const pv = pageviews();

  /* A person who came back from the push host by navigation (the window
     was blocked, or they opened it themselves) carries the answer in the
     hash, because no postMessage could reach us. Read it, keep it, clear it. */
  const back = /(^|[#&])juce-push=(on|later)\b/.exec(location.hash || '');
  if (back) {
    write({ state: back[2] === 'on' ? 'on' : 'later', at: Date.now(), wait: 0 });
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* fine */ }
  }

  /* Doors first: they work whether or not the card ever shows. */
  document.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target.closest('[data-push-open], [data-pushp-go], [data-pushp-later], [data-pushp-alt]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-pushp-later')) {
      if (watching) watching();
      /* "Got it" on a face that asked for an install is not "maybe later" on
         the offer: it keeps that face's longer hold rather than resetting to
         the console's cadence. */
      const install = wearing === 'homescreen' || wearing === 'inapp';
      const laters = install ? Number(read().laters || 0) : Number(read().laters || 0) + 1;
      write({ state: 'later', at: Date.now(), wait: install ? INSTALL_WAIT : 0, laters: laters });
      count('later');
      hide();
      return;
    }
    /* The other way in, from the blocked face: the push host's own page,
       whose origin the browser has not blocked. */
    if (t.hasAttribute('data-pushp-alt')) {
      if (watching) watching();
      hide();
      openWindow('subscribe');
      return;
    }
    const door = t.hasAttribute('data-push-open');
    /* 'go' IS A TAP ON THE OFFER, not on every button. The blocked face wears
       the same element as "Try again", and counting that as a fresh yes-
       attempt is what made go and denied climb together in the first week
       while nobody was subscribing: the same refusing browsers, re-asked
       every three days, each adding a tap that could never have worked. */
    if (door) count('door');
    else if (wearing !== 'blocked') count('go');
    /* A door in a browser that is already in is the manage page. */
    if (door && read().state === 'on') { openWindow('prefs'); return; }
    /* The tap came from a door with no card on screen: the card is where
       the browser's answer and the receipt are shown, so it comes up. */
    if (card && card.hidden) show();
    if (inApp) { inapp(); return; }
    if (ios && !standalone) { homescreen(); return; }
    if (!here) { openWindow('subscribe'); return; }
    if (perm() === 'denied') { blocked(); return; }
    void subscribeHere();
  });

  /* THE ACCOUNT PAGE'S ROW (2026-09-23): "Notify me on this device" beside
     Email me, Text me and WhatsApp me - see snippets/acct-prefs.liquid. A
     tick is a door: counted as one, the browser's Allow opens on it, and the
     card in the corner says what the browser did. It is on the CLICK, not
     the change, so Safari still sees the tap when requestPermission runs.
     Shown only where that one tap can work; ticked and settled once this
     browser is in, unticked again if the browser says no. */
  const offerRows = Array.from(document.querySelectorAll('[data-push-offer]'));
  function paintOffers() {
    const can = Boolean(here && cfg && cfg.enabled && perm() !== 'denied');
    const on = read().state === 'on';
    for (const row of offerRows) {
      const box = row.querySelector('[data-push-offer-box]');
      if (!box) continue;
      if (on) {
        /* Said yes on this page: keep the tick. In from before: nothing to offer. */
        if (!row.hidden) { box.checked = true; box.disabled = true; }
        continue;
      }
      row.hidden = !can;
    }
  }
  document.addEventListener('click', (e) => {
    const box = e.target && e.target.matches && e.target.matches('[data-push-offer-box]') ? e.target : null;
    if (!box || !box.checked || box.disabled) return;
    count('door');
    if (card && card.hidden) show();
    if (perm() === 'denied') { box.checked = false; blocked(); return; }
    subscribeHere().then(() => {
      if (read().state !== 'on') box.checked = false;
      paintOffers();
    });
  });
  if (!supported) {
    document.querySelectorAll('[data-push-open]').forEach((el) => { el.hidden = true; });
    return;
  }

  /* AFTER THE PAGE, NOT BESIDE IT (2026-09-22, lane 8). The config read is a
     cross-origin fetch to the push host, and it went out while the page was
     still downloading its pictures - on a phone's link, on every page, for a
     card that waits six seconds and a banner answer before it may show. It
     now starts once the page has loaded and the main thread is idle (three
     seconds at most). A door tapped before then still works:
     subscribeHere() reads the config for itself. */
  const afterPage = new Promise((resolve) => {
    const idle = () => (window.requestIdleCallback
      ? window.requestIdleCallback(() => resolve(), { timeout: 3000 })
      : window.setTimeout(resolve, 1500));
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  });
  afterPage.then(config).then(async (c) => {
    if (!c || !c.enabled) {
      document.querySelectorAll('[data-push-open]').forEach((el) => { el.hidden = true; });
      return;
    }
    fill(c);
    /* THE TRUTH BEFORE THE MARK. A browser that is in is left alone,
       whatever its storage remembers, and the mark is put back so the footer
       door opens the manage page - but "in" is now the server's answer, not
       the worker's say-so, and a yes whose POST never landed is filed first
       (settle, F3). */
    try { await settle(c); } catch (e) { /* the card decides on the mark it has */ }
    paintOffers();
    void reconcile();
    /* THE QUIET RE-CHECK, EVERY VISIT, THAT SHOWS NOTHING (2026-09-12,
       owner: "if anything is denied or not supported not show, but check
       every day or whenever the visit the website tho... but not in a
       flagging triggerng way"). A shut lane is shut against ASKING, not
       against looking. The permission is read fresh on every page here, so
       the moment somebody turns notifications back on for juce.co.za - in
       the browser's settings, on the bell, days later, for their own
       reasons - this sees it on their next visit and finishes the job
       silently: no card, no prompt, no interruption of any kind. Turning it
       on IS the answer; asking them to tap a button and confirm what they
       have just said would be the flagging they asked not to have.

       WHAT IT WILL NOT DO is treat a granted permission as a yes on its own.
       A browser can carry an old Allow from a subscription that was
       deliberately switched off ('off'), or sit behind a "Maybe later"
       ('later'), and reviving either would be putting words in somebody's
       mouth. Only the two states that mean "this browser was refusing"
       recover here. */
    const before = read();
    if (here && perm() === 'granted' && (before.state === 'blocked' || before.state === 'asked')) {
      /* Counted apart, because they are different stories. 'asked' is the
         prompt this card opened, tucked away by a quiet UI and allowed on
         the bell a minute or a day later - it has always been counted as a
         granted prompt and still is. 'blocked' is somebody who went into
         the browser's settings, found juce.co.za and turned it back on with
         no prompt in front of them, which is the strongest yes this card
         ever gets and was invisible until now. */
      /* COUNTED ONCE PER BROWSER, not once per visit. The subscribe below
         can fail for reasons that have nothing to do with the person - the
         CDN would not serve the worker, the push host was down - and the
         mark stays 'blocked' when it does, on purpose, so the next visit
         tries again. Without this guard that retry re-counts the recovery
         every time, and a single browser with a bad network reads as a
         stream of people changing their minds. */
      if (!before.recovered) {
        write({ recovered: Date.now() });
        count(before.state === 'blocked' ? 'recovered' : 'granted');
      }
      void subscribeHere();
      return;
    }
    /* The permission as it stands, kept so the shop can see a browser change
       its mind at all. A local mark, written only when it moves. */
    if (before.perm !== perm()) write({ perm: perm(), permAt: Date.now() });

    const standing = read();
    if (standing.state === 'on') return;
    /* (A tap given, the browser holding the question, and the Allow arriving
       after this page was left is handled by the quiet re-check above, which
       now covers the unblock case as well and counts the two apart.) */
    /* A tap whose answer the browser is still holding ('asked') comes
       straight back: no page count, no delay - only the cookie card's right
       of way. So does a 'blocked' whose block was lifted in the browser's
       settings since (the page reloads when that is done). A card that was
       only shown and left unanswered does not (2026-10-16, markAsk).

       THE HOME SCREEN COPY NO LONGER JUMPS THE QUEUE (2026-09-12, owner:
       "So when you in the app it will try and request the notify also
       then?"). It used to, and the note here said why: "the person put it
       there because the card told them to, and its storage starts empty".
       That was true when THIS card was the only thing that ever asked
       anybody to install - it said Apple delivers notifications only to a
       Home Screen app, so somebody who followed it had already said yes to
       notifications in all but the tap.

       It is not true any more. The install card is what sends people there
       now, and it sells the app: new scents first, a faster way back in. Not
       a word about notifications. So an iPhone opening the app for the first
       time is somebody who has just arrived, on a FRESH JAR - which on iOS
       means the cookie banner is asking too, because Apple gives the Home
       Screen app its own storage and there is no consent record in it. The
       fast path put the notification question six seconds behind the cookie
       card on the first screen of a brand new app. Two questions in the
       first minute of something they just installed is the bombardment this
       whole ordering exists to prevent.

       So the app is treated like any other browser: it waits out the page
       count and asks while they browse, which is the one place on an iPhone
       where the answer can actually be delivered. */
    const resuming = standing.state === 'asked'
      || (standing.state === 'blocked' && perm() !== 'denied');
    if (!resuming && pv < (Number(c.prompt && c.prompt.minPages) || 3)) return;
    whenDecided(() => {
      const delay = resuming && standing.state ? 250 : Math.max(0, Number(c.prompt && c.prompt.delayMs) || 6000);
      setTimeout(() => whenVisible(() => {
        if (!eligible(c) || gateOpen()) return;
        present();
      }), delay);
    });
  });
})();
